import { environment as DEFAULT_ENVIROMENT } from './environment.default';

export const environment = {
	...DEFAULT_ENVIROMENT,
	apiURL: 'https://segurcaixa-function-dev.azurewebsites.net/api/',
	authSettings: {
		clientId: 'dcb6d892-ebf4-11ec-8ea0-0242ac120002',
		authority: 'https://loginpre.segurcaixaadeslas.es/auth/realms/ssoextpreadeslas-2',
		scope: 'openid token'
	},
	production: false,
	name: 'Pre-environment',
	useMock: false,
	dataUrl: false
};